import { browser } from '$app/environment';
import { growthBook } from '$services/growthBook';
import { Guard, type GuardRun } from '../utils/Guard';

export class RequireDomainMigration extends Guard implements GuardRun {
  async run() {
    if (!browser) {
      return;
    }

    if (!growthBook?.isOn('gnosis_io_domain_migration')) {
      return;
    }

    if (window.sessionStorage.getItem('use_metri') === 'true') {
      return;
    }

    const hostname = window.location.hostname;

    const isOldDomain =
      hostname === 'deploy-preview-2286.app.metri.xyz' ||
      hostname === 'app.metri.xyz' ||
      hostname.includes('localhost');

    // Skip migration for certain paths
    const skipPaths = [
      '/migrate-domain',
      '/migrate-domain/validate',
      '/migrate-domain/create-passkey',
      '/migrate-domain/success',
      '/recovery',
    ];

    const isOnMigrationPath = skipPaths.some((path) => this.target.startsWith(path));

    //force migration for authenticated users on the old domain
    if (isOldDomain && !isOnMigrationPath) {
      return this.redirectTo('/migrate-domain');
    }
  }
}
